import script from "./NewAutomationModal.vue?vue&type=script&setup=true&lang=js"
export * from "./NewAutomationModal.vue?vue&type=script&setup=true&lang=js"

import "./NewAutomationModal.vue?vue&type=style&index=0&id=1ab93d57&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ab93d57"]])

export default __exports__